<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Баланс хисобот")}}</h5>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="table-input" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="table-input" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Склад</label>
        <v-select
          class="form-control-sm md-input"
          :options="skladlist"
                      :disabled="skladhave"
          v-model="datas.sklad_id"
          :clearable="false"
          :reduce="name => name.id"
          label="name"
        >
        <template #search="{ attributes, events }">
          <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
            aria-activedescendant="null"
          />
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            <em
              ><b>{{ search }}</b></em
            >
            {{ $t("бўйича маьлумот йўқ") }}
          </template>
          <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
        </template>
        </v-select>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Курс") }}</label>
        <div style="background: white;text-align: end;padding: 2px 5px;border-radius: 5px;border: 1px solid #aaa;">
        {{dollar_rate|numFormat}}
        </div>
        <!-- <input class="form-control" readonly type="text" v-model="dollar_rate" /> -->
      </b-col>
      <b-col lg="3" class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
      </b-col>
      <div class="limiter" id="tableId">
        <div class="container-table100">
          <div class="wrap-table100">
            <div class="table100 ver1 m-b-110">
              <div class="table100-head">
                <table>
                  <thead>
                    <tr class="row100 head">
                      <th class="cell100 column5"></th>
                      <th class="cell100 column4">
                        {{ $t("Бошланғич қолдиқ") }}
                      </th>
                      <th class="cell100 column3">{{ $t("Кирим") }}</th>
                      <th class="cell100 column3">{{ $t("Расход") }}</th>
                      <th class="cell100 column4">{{ $t("Якуний қолдиқ") }}</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="table100-body" v-if="results.product" style="max-height: 90vh!important;">
                <table>
                  <tbody>
                    <!-- tovar xisobi -->
                    <tr class="row100 body">
                      <td class="cell100 column5">
                        {{ $t("Товар хисоботи") }}
                      </td>
                      <td class="cell100 kol column4">
                        <span v-if="results.product.begin_total!=0"
                          :class="{ red: results.product.begin_total < 0 }"
                          >{{ results.product.begin_total | numFormats }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.product.total_kirim!=0">
                        {{ results.product.total_kirim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.product.total_chiqim!=0">
                        {{ results.product.total_chiqim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span :class="{ red: results.product.end_total < 0 }" v-if="results.product.end_total!=0">{{
                          results.product.end_total | numFormats
                        }}</span>
                      </td>
                    </tr>
                                        <!-- boshqa skladlar -->
                    <tr class="row100 body" v-if="datas.sklad_id == 1">
                      <td class="cell100 column5">
                        {{ $t("Бошқа омборлар") }}
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{
                            red: results.product_others.begin_total < 0
                          }" v-if="results.product_others.begin_total!=0"
                          >{{
                            results.product_others.begin_total | numFormats
                          }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span  v-if="results.product_others.total_kirim!=0">
                        {{ results.product_others.total_kirim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span  v-if="results.product_others.total_chiqim!=0">
                        {{ results.product_others.total_chiqim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span  v-if="results.product_others.end_total!=0"
                          :class="{ red: results.product_others.end_total < 0 }"
                          >{{
                            results.product_others.end_total | numFormats
                          }}</span
                        >
                      </td>
                    </tr>
                    <span
                      style="display: contents;"
                      v-for="item in results.product_others.items"
                      :key="item.id"
                    >
                      <tr class="row100 body" v-if="datas.sklad_id == 1" style="background-color: rgb(217 201 201);">
                        <td class="cell100 column5 kol">{{ item.sklad }}</td>
                        <td class="cell100 kol column4">
                          <span v-if="item.begin_total!=0" :class="{ red: item.begin_total < 0 }">{{
                            item.begin_total | numFormats
                          }}</span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item.total_kirim!=0">
                          {{ item.total_kirim | numFormats }}
                          </span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item.total_chiqim!=0">
                          {{ item.total_chiqim | numFormats }}
                          </span>
                        </td>
                        <td class="cell100 kol column4">
                          <span :class="{ red: item.end_total < 0 }" v-if="item.end_total!=0">{{
                            item.end_total | numFormats
                          }}</span>
                        </td>
                      </tr>
                    </span>
                    <!-- kontragent  -->
                    <span
                      style="display: contents;"
                      v-for="item in results.kontragent"
                      :key="item.id"
                    >
                    <tr class="row100 body">
                      <td class="cell100 column5">
                        <span  v-if="item.pay_type!=null">
                        {{ $t("Контрагент хисоботи")+ ' ('+ item.pay_type.name+')' }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span
                        v-if="item.begin_total!=0"
                          :class="{ red: item.begin_total < 0 }" 
                          >{{
                            item.begin_total | numFormats
                          }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span  v-if="item.total_kirim!=0"
                        >
                        {{ item.total_kirim | numFormats }}
                      </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="item.total_chiqim!=0">
                        {{ item.total_chiqim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span v-if="item.end_total!=0"
                          :class="{ red: item.end_total < 0 }"
                          >{{ item.end_total | numFormats }}</span
                        >
                      </td>
                    </tr>
                    </span>
                    <!-- kassa kitobi -->
                    <span
                      style="display: contents;"
                      v-for="item in results.kassa"
                      :key="item.id"
                    >
                      <tr class="row100 body">
                        <td class="cell100 column5">
                          <span v-if="item.pay_type!=null">
                          {{ $t("Касса китоби") }}({{ item.pay_type.name }})
                        </span>
                        </td>
                        <td class="cell100 kol column4">
                          <span :class="{ red: item.begin_total < 0 }" v-if="item.begin_total!=0">{{
                            item.begin_total | numFormats
                          }}</span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item.total_kirim!=0">
                          {{ item.total_kirim | numFormats }}
                        </span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item.total_chiqim!=0">
                          {{ item.total_chiqim | numFormats }}
                        </span>
                        </td>
                        <td class="cell100 kol column4">
                          <span :class="{ red: item.end_total < 0 }" v-if="item.end_total!=0">{{
                            item.end_total | numFormats
                          }}</span>
                        </td>
                      </tr>
                    </span>
                    <!-- boshlangich qoldiq
                    <tr class="row100 body">
                      <td class="cell100 column5">
                        {{ $t("Бошланғич қолдиқ") }}
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{
                            red: results.initial_balance.begin_total < 0
                          }"
                          >{{
                            results.initial_balance.begin_total | numFormats
                          }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        {{ results.initial_balance.total_kirim | numFormats }}
                      </td>
                      <td class="cell100 kol column3">
                        {{ results.initial_balance.total_chiqim | numFormats }}
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{
                            red: results.initial_balance.end_total < 0
                          }"
                          >{{
                            results.initial_balance.end_total | numFormats
                          }}</span
                        >
                      </td>
                    </tr> -->
                    <!-- jami -->
                    <tr class="row100 body jami">
                      <td class="cell100 column5">
                        {{ $t("Жами") }}
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{
                            red: summa.begin_total < 0
                          }" v-if="summa.begin_total!=0"
                          >{{
                            summa.begin_total | numFormats
                          }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="summa.total_kirim!=0">
                        {{ summa.total_kirim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="summa.total_chiqim!=0">
                        {{ summa.total_chiqim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{
                            red: summa.end_total < 0
                          }" v-if="summa.end_total!=0"
                          >{{
                            summa.end_total | numFormats
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr class="row100 body">
                      <td class="cell100" style="height: 15px;" colspan="5"> </td>
                    </tr>
                     <!-- skidka -->
                     <tr class="row100 body">
                      <td class="cell100 column5">{{ $t("Скидка") }}</td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{ red: results.skidka.begin_total > 0 }" v-if="results.skidka.begin_total!=0"
                          >{{ results.skidka.begin_total*-1 | numFormats }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.skidka.total_chiqim!=0">
                        {{ results.skidka.total_chiqim | numFormats }}
                      </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.skidka.total_kirim!=0">
                        {{ results.skidka.total_kirim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span :class="{ red: results.skidka.end_total > 0 }" v-if="results.skidka.end_total!=0">{{
                          results.skidka.end_total*-1 | numFormats
                        }}</span>
                      </td>
                    </tr> 
                    <!-- xarajat -->
                    <span
                      style="display: contents;"
                      v-for="item1 in results.kassa_order"
                      :key="item1.id"
                    >
                      <tr class="row100 body">
                        <td class="cell100 column5">
                          <span v-if="item1.pay_type!=null">
                          {{ $t("Харажат") }}({{ item1.pay_type.name }})
                          </span>
                        </td>
                        <td class="cell100 kol column4">
                          <span :class="{ red: item1.begin_total < 0 }" v-if="item1.begin_total !=0">{{
                            item1.begin_total | numFormats
                          }}</span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item1.total_kirim!=0">
                          {{ item1.total_kirim | numFormats }}
                          </span>
                        </td>
                        <td class="cell100 kol column3">
                          <span v-if="item1.total_chiqim!=0">
                          {{ item1.total_chiqim | numFormats }}
                          </span>
                        </td>
                        <td class="cell100 kol column4">
                          <span :class="{ red: item1.end_total < 0 }" v-if="item1.end_total!=0">{{
                            item1.end_total | numFormats
                          }}</span>
                        </td>
                      </tr>
                    </span>
                    <!-- foyda xisobot -->
                    <tr class="row100 body">
                      <td class="cell100 column5">
                        {{ $t("Фойда хисоботи") }}
                      </td>
                      <td class="cell100 kol column4">
                        <span
                          :class="{ red: results.profit.begin_total < 0 }" v-if="results.profit.begin_total!=0"
                          >{{ results.profit.begin_total | numFormats }}</span
                        >
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.profit.total_kirim!=0">
                        {{ results.profit.total_kirim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column3">
                        <span v-if="results.profit.total_chiqim!=0">
                        {{ results.profit.total_chiqim | numFormats }}
                        </span>
                      </td>
                      <td class="cell100 kol column4">
                        <span :class="{ red: results.profit.end_total < 0 }" v-if="results.profit.end_total!=0">{{
                          results.profit.end_total | numFormats
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <sklad :datas="datas"></sklad>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");

var FileSaver = require("file-saver");
import { Sklad } from "@/pages";
import { print } from "../../../components/mixins/print.js";
export default {
  components: { Sklad},
  mixins: [print],
  data() {
    return {
      dollar_rate:0,
      pricesettings:{},
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        pay_type_id: null,
        sklad_id: parseInt(localStorage.getItem("sklad_id"))
      },
      paytype: "",
      paytypelist: [],
      sklad: "",
      skladlist: [],
      errors: "",
      summa:{begin_total:0,total_kirim:0,total_chiqim:0,end_total:0},
      results: []
    };
  },
  created() {
    let self = this;
    axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dollar_rate=response.data.rate;
        });
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.Pricesettings();
  },
  methods: {
    Pricesettings() {
        let self = this;
        axios.get("api/v1/sklads/id/1").then(function (response) {
          self.pricesettings = { common_price_type: response.data.common_price_type, chakana_price_type: response.data.chakana_price_type, optom_price_type: response.data.optom_price_type };
        });
      },
    Setted: function(item1) {
      item1.total = 0;
      item1.naqd = 0;
      item1.plastik = 0;
      item1.skidka = 0;
      item1.nasiya = 0;
      item1.forEach(function(key, value) {
        item1.total += key.total;
        item1.naqd += key.total_cash;
        item1.nasiya += key.total_credit;
        item1.skidka += key.total_skidka;
        item1.plastik += key.total_plastic;
      });
      return item1.naqd;
    },
    downloadExl() {
      this.$store.state.xls=true;
setTimeout(() => {
  let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
        var wscols = [{ width: 35 },{ width: 18 },{ width: 13 },{ width: 13 },{ width: 18 }]; 
        wb.Sheets.Sheet1['!cols']=wscols;
        let wbout = XLSX.write(wb, wopts);
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charsetted=utf-8"
        }),
        new Date() + "balans_xisobot.xlsx"
      );
      setTimeout(() => {
        this.$store.state.xls=false;
      }, 2000);
}, 1000);
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1)
            .valueOf()
            .toString()
            .slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2)
              .valueOf()
              .toString()
              .slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id
      };
      axios({
        method: "post",
        url: "api/v1/report/balance",
        data: datas
      }).then(function(response) {
        self.summa.begin_total=0;
          self.summa.total_kirim=0;
          self.summa.total_chiqim=0;
          self.summa.end_total=0;
        self.results = response.data;
          response.data.kassa.forEach(function (key, value) {
          if(self.pricesettings.common_price_type==1 && key.pay_type_id==3){
            key.begin_total=key.begin_total*self.dollar_rate;
            key.total_kirim=key.total_kirim*self.dollar_rate;
            key.total_chiqim=key.total_chiqim*self.dollar_rate;
            key.end_total=key.end_total*self.dollar_rate;
          }else if(self.pricesettings.common_price_type==2 && key.pay_type_id!=3){
            key.begin_total=key.begin_total/self.dollar_rate;
            key.total_kirim=key.total_kirim/self.dollar_rate;
            key.total_chiqim=key.total_chiqim/self.dollar_rate;
            key.end_total=key.end_total/self.dollar_rate;
          }
          self.summa.begin_total+=key.begin_total;
          self.summa.total_kirim+=key.total_kirim;
          self.summa.total_chiqim+=key.total_chiqim;
          self.summa.end_total+=key.end_total;
        });
        response.data.kassa_order.forEach(function (key, value) {
          if(self.pricesettings.common_price_type==1 && key.pay_type_id==3){
            key.begin_total=key.begin_total*self.dollar_rate;
            key.total_kirim=key.total_kirim*self.dollar_rate;
            key.total_chiqim=key.total_chiqim*self.dollar_rate;
            key.end_total=key.end_total*self.dollar_rate;
          }else if(self.pricesettings.common_price_type==2 && key.pay_type_id!=3){
            key.begin_total=key.begin_total/self.dollar_rate;
            key.total_kirim=key.total_kirim/self.dollar_rate;
            key.total_chiqim=key.total_chiqim/self.dollar_rate;
            key.end_total=key.end_total/self.dollar_rate;
          }
          // self.summa.begin_total+=key.begin_total;
          // self.summa.total_kirim+=key.total_kirim;
          // self.summa.total_chiqim+=key.total_chiqim;
          // self.summa.end_total+=key.end_total;
        });
        response.data.kontragent.forEach(function (key, value) {
          if(self.pricesettings.common_price_type==1 && key.pay_type_id==3){
            key.begin_total=key.begin_total*self.dollar_rate;
            key.total_kirim=key.total_kirim*self.dollar_rate;
            key.total_chiqim=key.total_chiqim*self.dollar_rate;
            key.end_total=key.end_total*self.dollar_rate;
          }else if(self.pricesettings.common_price_type==2 && key.pay_type_id!=3){
            key.begin_total=key.begin_total/self.dollar_rate;
            key.total_kirim=key.total_kirim/self.dollar_rate;
            key.total_chiqim=key.total_chiqim/self.dollar_rate;
            key.end_total=key.end_total/self.dollar_rate;
          }
          self.summa.begin_total+=key.begin_total;
          self.summa.total_kirim+=key.total_kirim;
          self.summa.total_chiqim+=key.total_chiqim;
          self.summa.end_total+=key.end_total;
        });
        if(self.datas.sklad_id == 1){
          self.summa.begin_total+=self.results.product_others.begin_total;
          self.summa.total_kirim+=self.results.product_others.total_kirim;
          self.summa.total_chiqim+=self.results.product_others.total_chiqim;
          self.summa.end_total+=self.results.product_others.end_total;
        }
        // self.summa.begin_total+=self.results.product.begin_total-self.results.skidka.begin_total;
        // self.summa.total_kirim+=self.results.product.total_kirim+self.results.skidka.total_chiqim;
        // self.summa.total_chiqim+=self.results.product.total_chiqim+self.results.skidka.total_kirim;
        // self.summa.end_total+=self.results.product.end_total-self.results.skidka.end_total;
        self.summa.begin_total+=self.results.product.begin_total;
        self.summa.total_kirim+=self.results.product.total_kirim;
        self.summa.total_chiqim+=self.results.product.total_chiqim;
        self.summa.end_total+=self.results.product.end_total;
      });
    }
  }
};
</script>
